




















































import { Component, Emit, Vue, Watch, Prop } from 'vue-property-decorator';
import CommonInput from './unit/components/commonInput/commonInput.vue';
import TextareaInput from './unit/components/textareaInput/textareaInput.vue';
import NumberInput from './unit/components/numberInput/numberInput.vue';
import RadioInput from './unit/components/radioInput/radioInput.vue';
import MultipleInput from './unit/components/multipleInput/multipleInput.vue';
import DateSelection from './unit/components/dateSelection/dateSelection.vue';
import DateRange from './unit/components/dateRange/dateRange.vue';
import ExplanatoryText from './unit/components/explanatoryText/explanatoryText.vue';
import ImageInput from './unit/components/imageInput/imageInput.vue';
import RelatedApprovalInput from './unit/components/relatedApprovalInput/relatedApprovalInput.vue';
import AmountInput from './unit/components/amountInput/amountInput.vue';
import DiscountInput from './unit/components/discoountInput/discountInput.vue';
import AppendixInput from './unit/components/appendixInput/appendixInput.vue';
import SignatureInput from './unit/components/signatureInput/signatureInput.vue';
import ExternalContactsInput from './unit/components/externalContactsInput/externalContactsInput.vue';
import ContactsInput from './unit/components/contactsInput/contactsInput.vue';
import DepartmentInput from './unit/components/departmentInput/departmentInput.vue';
import PlaceInput from './unit/components/placeInput/placeInput.vue';
import CalculationFormulaInput from './unit/components/calculationFormulaInput/calculationFormulaInput.vue';
import ElectronicInvoiceInput from './unit/components/electronicInvoiceInput/electronicInvoiceInput.vue';
import Equipment from './unit/components/equipment/equipment.vue';
import EquipmentStandard from './unit/components/equipmentStandard/equipmentStandard.vue';

import { create } from '@/util/createApi';

@Component({
  components: {
    CommonInput,
    TextareaInput,
    NumberInput,
    RadioInput,
    MultipleInput,
    DateSelection,
    DateRange,
    ExplanatoryText,
    ImageInput,
    RelatedApprovalInput,
    AmountInput,
    DiscountInput,
    AppendixInput,
    SignatureInput,
    ExternalContactsInput,
    ContactsInput,
    DepartmentInput,
    PlaceInput,
    CalculationFormulaInput,
    ElectronicInvoiceInput,
    Equipment,
    EquipmentStandard,
  },
})
export default class FormDesign extends Vue {
  private unitBox: any = {
    TextareaInput,
    CommonInput,
    NumberInput,
    RadioInput,
    MultipleInput,
    DateSelection,
    DateRange,
    ExplanatoryText,
    ImageInput,
    RelatedApprovalInput,
    AmountInput,
    DiscountInput,
    AppendixInput,
    SignatureInput,
    ExternalContactsInput,
    ContactsInput,
    DepartmentInput,
    PlaceInput,
    CalculationFormulaInput,
    ElectronicInvoiceInput,
    Equipment,
    EquipmentStandard,
  }; // 组件注册
  private incrementalId: any = 0; // 组件创建时自增id 区分组件
  private sortId: any = []; // 根据自增id的排序数组 控制组件顺序

  private type: any; // 动态渲染组件的类型
  private pushType: any; // 组件的动态渲染方式 bottom-底部渲染 top-拖拽到的位置的上部渲染 no-不渲染
  private unitList: any[] = [
    {
      type: 'CommonInput',
      name: '单行输入框',
      icon: 'el-icon-edit',
    },
    {
      type: 'TextareaInput',
      name: '多行输入框',
      icon: 'el-icon-edit-outline',
    },
    {
      type: 'NumberInput',
      name: '数字输入框',
      icon: 'el-icon-edit',
    },
    {
      type: 'RadioInput',
      name: '单选框',
      icon: 'el-icon-finished',
    },
    {
      type: 'MultipleInput',
      name: '多选框',
      icon: 'el-icon-finished',
    },
    {
      type: 'DateSelection',
      name: '日期',
      icon: 'el-icon-date',
    },
    {
      type: 'DateRange',
      name: '日期区间',
      icon: 'el-icon-date',
    },
    {
      type: 'ExplanatoryText',
      name: '说明文字',
      icon: 'el-icon-chat-round',
    },
  ]; // 左部组件 基础控件 type-组件类型 name-显示的组件名称 icon-显示的图标

  private enhanceList: any[] = [
    {
      type: 'ImageInput',
      name: '图片',
      icon: 'el-icon-picture-outline',
    },
    {
      type: 'RelatedApprovalInput',
      name: '关联审批单',
      icon: 'el-icon-link',
    },
    {
      type: 'AmountInput',
      name: '金额',
      icon: 'el-icon-coin',
    },
    {
      type: 'DiscountInput',
      name: '折扣',
      icon: 'el-icon-s-check',
    },
    {
      type: 'AppendixInput',
      name: '附件',
      icon: 'el-icon-notebook-1',
    },
    {
      type: 'SignatureInput',
      name: '手写签名',
      icon: 'el-icon-notebook-2',
    },
    {
      type: 'ExternalContactsInput',
      name: '外部联系人',
      icon: 'el-icon-notebook-2',
    },
    {
      type: 'ContactsInput',
      name: '联系人',
      icon: 'el-icon-notebook-1',
    },
    {
      type: 'DepartmentInput',
      name: '部门',
      icon: 'el-icon-notebook-2',
    },
    {
      type: 'PlaceInput',
      name: '地点',
      icon: 'el-icon-office-building',
    },
    {
      type: 'CalculationFormulaInput',
      name: '计算公式',
      icon: 'el-icon-document-add',
    },
    {
      type: 'ElectronicInvoiceInput',
      name: '电子发票',
      icon: 'el-icon-tickets',
    },
    {
      type: 'Equipment',
      name: '设备选择器',
      icon: 'el-icon-box',
    },
    {
      type: 'EquipmentStandard',
      name: '设备标准卡',
      icon: 'el-icon-price-tag',
    },
  ]; // 左部组件 增强控件 type-组件类型 name-显示的组件名称 icon-显示的图标
  private changeColorEl: any; // 改变颜色的dom的event
  private equipmentType: any = '2'; // 展示页面的设备类型 1pc 2移动

  private unitForm: any = [];

  @Prop() formData: any;

  mounted() {
    if (this.formData && this.formData.length > 0) {
      console.log(this.formData);
      this.$nextTick(() => {
        this.editForm();
      });
    }
  }

  // 处理标签点击才有数据问题 editForm
  editForm() {
    const map: any = {
      Input: 'CommonInput',
      Images: 'ImageInput',
      Text: 'TextareaInput',
      Radio: 'RadioInput',
      ContactPerson: 'ContactsInput',
      Location: 'PlaceInput',
      facilityList: 'Equipment',
      facilityStandredList: 'EquipmentStandard',
    };
    this.formData.forEach((item: any, index: any) => {
      const name = item.componentName;
      // const type = map[name];
      // this.formData[index].form = item.props;

      const el = document.getElementById('_unit_box');

      const props: any = {
        unitId: this.incrementalId,
        formProp: item.form,
      };

      const comp = create((this.unitBox as any)[item.type], props, el, 'bottom');

      comp.$on('i_close', (e: any) => {
        comp.remove();
        this.delUnitList(e);
      });

      comp.$on('unit_set_data', (e: any) => {
        this.unitSetData(e);
      });

      const data: any = {
        form: item.form,
        type: item.type,
        id: this.incrementalId,
      };
      this.setData(data, 'push');

      this.incrementalId++;
    });
  }

  // 处理标签点击才有数据问题前的editForm
  // editForm() {
  //   const map: any = {
  //     Input: 'CommonInput',
  //     Images: 'ImageInput',
  //     Text: 'TextareaInput',
  //     Radio: 'RadioInput',
  //     ContactPerson: 'ContactsInput',
  //     Location: 'PlaceInput',
  //   };
  //   this.formData.forEach((item: any, index: any) => {
  //     const name = item.componentName;
  //     const type = map[name];
  //     this.formData[index].form = item.props;
  //
  //     const el = document.getElementById('_unit_box');
  //
  //     const props: any = {
  //       unitId: this.incrementalId,
  //       formProp: item.props,
  //     };
  //
  //     const comp = create((this.unitBox as any)[type], props, el, 'bottom');
  //
  //     comp.$on('i_close', (e: any) => {
  //       comp.remove();
  //       this.delUnitList(e);
  //     });
  //
  //     comp.$on('unit_set_data', (e: any) => {
  //       this.unitSetData(e);
  //     });
  //
  //     const data: any = {
  //       form: item.props,
  //       type: type,
  //       id: this.incrementalId,
  //     };
  //     this.setData(data, 'push');
  //
  //     this.incrementalId++;
  //   });
  // }

  /**
   * @desc 切换pc、移动显示方式
   * @param type - 1pc 2移动
   */
  private equipmentTypeChange(type: any) {
    this.equipmentType = type;
  }

  /**
   * @desc 开始拖拽
   * @param e - 拖拽对象 event
   */
  private dragStart(e: any) {
    this.type = e.target.dataset.type;
  }

  /**
   * @desc 结束拖拽
   */
  private dragEnd() {}

  /**
   * @desc 放开拖拽
   * @param e - 拖拽对象 event
   */
  private drop(e: any) {
    e.preventDefault();
    e.stopPropagation();

    if (this.pushType === 'no') {
      return false;
    }

    if (this.changeColorEl) {
      this.changeColorEl.target.classList.add('push-hover-transition');
      this.changeColorEl.target.classList.remove('push-hover');
      setTimeout(() => {
        this.changeColorEl.target.classList.remove('push-hover-transition');
      }, 200);
    }
    let el;

    const data: any = {
      form: {},
      type: this.type,
      id: this.incrementalId,
    };

    if (this.pushType === 'bottom') {
      el = document.getElementById('_unit_box');
      this.sortId.push(this.incrementalId);
      this.setData(data, 'push');
    }
    if (this.pushType === 'top') {
      el = this.changeColorEl.target;
      const index = this.sortId.indexOf(Number(this.changeColorEl.target.dataset.unitid));
      this.sortId.splice(index, 0, this.incrementalId);
      this.setData(data, index);
    }

    const props: any = {
      unitId: this.incrementalId,
      formProp: {},
    };

    const comp = create((this.unitBox as any)[this.type], props, el, this.pushType);

    comp.$on('i_close', (e: any) => {
      comp.remove();
      this.delUnitList(e);
    });

    comp.$on('unit_set_data', (e: any) => {
      this.unitSetData(e);
    });

    this.incrementalId++;
  }

  setData(data: any, index: any) {
    if (index === 'push') {
      this.unitForm.push(data);
      console.log(this.unitForm);
    } else {
      this.unitForm.splice(index, 0, data);
    }
  }

  unitSetData(data: any) {
    console.log(data);
    this.unitForm.forEach((unit: any, formIndex: any) => {
      if (data.id === unit.id) {
        this.unitForm[formIndex].form = data.form;
      }
    });
  }

  /**
   * @desc 拖拽到可拖拽区域
   * @param e - 拖拽对象 event
   */
  private dragOver(e: any) {
    e.preventDefault();
    const className = e.target.className;
    if (className == 'right-main') {
      if (this.changeColorEl) {
        this.changeColorEl.target.classList.remove('push-hover');
      }
      this.pushType = 'bottom';
    } else if (className.indexOf('push-box') > -1) {
      e.target.classList.add('push-hover');
      this.changeColorEl = e;
      this.pushType = 'top';
    } else {
      if (this.changeColorEl) {
        this.changeColorEl.target.classList.remove('push-hover');
      }
      this.pushType = 'no';
    }
  }

  /**
   * @desc 删除组件数据
   * @param item - 删除对象
   */
  private delUnitList(item: any) {
    const index = this.sortId.indexOf(item.id);
    this.sortId.splice(index, 1);

    let unitIndex: any;
    this.unitForm.forEach((unit: any, formIndex: any) => {
      if (item.id === unit.id) {
        console.log(item);
        unitIndex = formIndex;
        this.unitForm.splice(unitIndex, 1);
      }
    });

    console.log(this.unitForm);
  }

  @Watch('unitForm', { deep: true })
  private setChangeData() {
    console.log(13123);
    const data = {
      formData: this.unitForm,
      type: 'form',
    };
    this.$emit('setData', data);
  }
}
